<template>
  <el-dialog
    class="dialog-wrapper roles-modal"
    visible
    :show-close="true"
    @close="closeAction"
  >
    <ContentHeader
      slot="title"
      :title="
        $t('operations.analysesWithoutOperations.dialog.title') +
        (analysisCount > 0 ? ` (${analysisCount})` : '')
      "
    />
    <el-row
      :gutter="20"
      type="flex"
    >
      <el-col :span="24">
        <div class="table-wrapper">
          <el-table :data="analyses">
            <el-table-column
              prop="code"
              :label="
                $t(
                  'operations.analysesWithoutOperations.dialog.table.header.code'
                )
              "
            />
            <el-table-column
              prop="description"
              :label="
                $t(
                  'operations.analysesWithoutOperations.dialog.table.header.description'
                )
              "
            />
            <el-table-column
              prop="commodityCategory"
              :label="
                $t(
                  'operations.analysesWithoutOperations.dialog.table.header.category'
                )
              "
            />
          </el-table>
        </div>
      </el-col>
    </el-row>
    <div style="display: flex; justify-content: end; margin-top: 0.5rem">
      <el-button
        type="secondary"
        @click.prevent="closeAction"
      >
        {{
          $t('operations.analysesWithoutOperations.dialog.button.close.label')
        }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { analysesApi } from '@/api';
  import ContentHeader from '@/components/ContentHeader.vue';

  const defaultData = {
    analyses: [],
  };

  export default {
    name: 'OperationsWithoutAnalysesDialog',
    components: {
      ContentHeader,
    },
    props: {},
    data() {
      return {
        analyses: defaultData.analyses,
      };
    },
    computed: {
      analysisCount() {
        return this.analyses.length;
      },
    },
    async mounted() {
      const loading = this.$loading({
        lock: true,
        background: 'rgba(48,53,82,0.9)',
      });
      const analyses = await analysesApi.analysesWithoutOperations();
      this.analyses = analyses.data;
      loading.close();
    },
    methods: {
      closeAction() {
        this.$emit('dialogClose');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .analysis-data {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    font-size: 16px;
    color: $--color-white;
  }
</style>
